import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './SideNavbar.css';
import { useAuth } from '../../context/AuthContext';
import Cookies from 'js-cookie';

const navItems = [
    { to: '/dashboard',        icon: 'fa-solid fa-gauge-high',           label: 'Dashboard' },
    { to: '/registered-users', icon: 'fa-solid fa-users',                label: 'Registered Users' },
    { to: '/categories',       icon: 'fa-solid fa-layer-group',          label: 'Categories' },
    { to: '/artists',          icon: 'fa-solid fa-paintbrush',           label: 'Artists' },
    { to: '/products',         icon: 'fa-solid fa-box-open',             label: 'Products' },
    { to: '/orders',           icon: 'fa-solid fa-bag-shopping',         label: 'Orders' },
    { to: '/subscriptions',    icon: 'fa-solid fa-bell',                 label: 'Subscriptions' },
    { to: '/donations',        icon: 'fa-solid fa-hand-holding-dollar',  label: 'Donations' },
    { to: '/contact-support',  icon: 'fa-solid fa-headset',              label: 'Contact Support' },
];

function SideNavbar() {
    const location  = useLocation();
    const navigate  = useNavigate();
    const { logout } = useAuth();
    const user = JSON.parse(Cookies.get('artfroAdminUser') || '{}');

    const isActive = (to) => location.pathname.startsWith(to);

    const handleLogout = () => { logout(); navigate('/'); };

    return (
        <>
            {/* Logo */}
            <div className="sidebar-logo-wrap">
                <img src="https://artfrocollection.com/images/logo.png" alt="Artfro" />
            </div>

            {/* Nav */}
            <div className="sidebar-section-label">Main Menu</div>
            <ul className="sidebar-nav">
                {navItems.map(({ to, icon, label }) => (
                    <li key={to} className="sidebar-item">
                        <NavLink
                            to={to}
                            className={`sidebar-link${isActive(to) ? ' active' : ''}`}
                            aria-label={label}
                        >
                            <i className={`${icon} snb-icon`} aria-hidden="true" />
                            <span>{label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>

            {/* Bottom user strip */}
            <div className="sidebar-user">
                <img
                    src={require('../../assets/bussinessman.jpeg')}
                    alt="avatar"
                    className="sidebar-user-avatar"
                />
                <div className="sidebar-user-info">
                    <div className="sidebar-user-name">{user.name || 'Admin'}</div>
                    <div className="sidebar-user-role">Administrator</div>
                </div>
                <button className="sidebar-logout-btn" onClick={handleLogout} title="Sign out">
                    <i className="fa-solid fa-right-from-bracket" />
                </button>
            </div>
        </>
    );
}

export default SideNavbar;
